export enum CollapseHeight {
  FIVE_HEIGHT = 180,
  TEN_HEIGHT = 360
}
